module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/llave_ZP.00b36e5b.svg";